import { Skeleton } from "antd";

import { LinkContainer } from "./BusinessSocialMediaLink.styles";

const BusinessSocialMediaLinkSkeleton: React.FC = () => {
  return (
    <LinkContainer>
      <Skeleton.Node active />
    </LinkContainer>
  );
};

export default BusinessSocialMediaLinkSkeleton;
